import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef } from "react";
import { useForm } from "react-hook-form";
import clsx from "clsx";
import { FaTimes } from "react-icons/fa";

export interface ISendToFinanceProps {
  reason: string;
}

export default function SendToFinanceModal({ open, onSave, setOpen }) {
  const cancelButtonRef = useRef(null);

  const formHook = useForm<ISendToFinanceProps>({
    mode: "onChange",
  });
  const isReasonFilled = !!formHook.watch("reason")?.trim().length;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className={`relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-4 sm:w-[480px] sm:p-6 flex flex-col `}
                >
                  <button onClick={handleClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
                    <FaTimes size={16} />
                  </button>
                  <div className="pb-2">
                    <div className="font-semibold text-sm">Send To Finance</div>
                  </div>
                  <div>
                    <div className="justify-start items-center gap-2 inline-flex mt-5">
                      <div className="flex justify-start items-center gap-1 p-2.5 w-[130px]">
                        <span className="font-normal text-black text-xs">Provide Reason</span>
                        <span className="font-normal text-rose-600 text-xs">*</span>
                      </div>
                      <div className="w-72">
                        <textarea
                          rows={4}
                          style={{
                            overflowY: "scroll",
                            scrollbarWidth: "thin",
                          }}
                          className={clsx(
                            `rounded-md w-full h-full border text-xs`,
                            formHook?.formState?.errors?.reason ? "outline-red-300 border-red-600" : "border-gray-300",
                          )}
                          placeholder="Please enter reason"
                          {...formHook.register(`reason`, {
                            required: true,
                            minLength: 1,
                          })}
                        />
                        {formHook?.formState?.errors?.reason && (
                          <p className="text-red-500 absolute text-[10px] -mt-1">Reason is required</p>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-end mt-3">
                      <button
                        onClick={formHook.handleSubmit((data) => onSave(data.reason))}
                        disabled={!isReasonFilled}
                        className={clsx(
                          "px-4 py-2 rounded-md text-white bg-[#193A6A] flex justify-end",
                          !isReasonFilled && "opacity-50 cursor-not-allowed",
                        )}
                      >
                        Send to Finance
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
